module.exports = __webpack_public_path__ + "img/reset.e7247e2d.jpg";